import Title from '../../microComponents/elements/Title';
import ComponentCard from '../../microComponents/elements/ComponentCard';
import UseSetParams from '../../microComponents/tablePages/filter/UseSetParams';
import DeleteFilterTable from '../../microComponents/tablePages/filter/DeleteFilterTable';
import CreatorTable from '../../microComponents/tablePages/CreatorTable';
import SeriesHistoryColumn from './SeriesHistoryColumn';
import React from "react";
import ExpandedSeriesHistory from "./ExpandedSeriesHistory";
import CollapseBox from "../../microComponents/tablePages/CollapseBox";
import ShowSearchBtn from "../../microComponents/tablePages/ShowSearchBtn";
import {useSelector} from "react-redux";
import TopSearchSeriesHistory from "./TopSearchSeriesHistory";
import {useNavigate} from "react-router-dom";


const SeriesHistory = () => {
    const showSearchBox = useSelector((state) => state.TableRedux.showSearchBox);

    const [columns] = SeriesHistoryColumn();
    const [, handleDeleteParams] = UseSetParams();
    const navigate = useNavigate();

    return (<div>
            <ComponentCard>
                <div className='flex justify-between'>
                    <Title>تاریخچه سری
                    </Title>
                    <div className='flex gap-2 items-center'>
                        <DeleteFilterTable onClick={handleDeleteParams}/>
                        <ShowSearchBtn/>
                    </div>
                </div>
                <div className='searchBox p-0'>
                    <CollapseBox activeKey={showSearchBox ? ['1'] : null} items={[{
                        showArrow: false, headerPadding: '1px', className: 'bg-white border-none',
                        key: '1', children: <TopSearchSeriesHistory/>,
                    }]}/>

                </div>
            </ComponentCard> <ComponentCard>
            <CreatorTable columns={columns} listAddress='ProductSeries'
                          rowClassName={(record) => (record.seriesStatus && "tableRowBgGreen")}
                          onDoubleClickRowHandler={(row) => {
                              navigate(`/PalletStatus?ProductSeri=${row.id}`);

                          }}

                          expandable={{
                              expandedRowRender: (row) => (

                                  <ExpandedSeriesHistory item={row}/>

                              ),
                          }}/>


        </ComponentCard></div>
    );
};


export default SeriesHistory;